module.exports = __webpack_public_path__ + "static/media/4.92c88e57.svg";